// src/router/index.js
import Router from 'vue-router';
import ProductFinder from "../Components/generator-finder/ProductFinder.vue";
import Recommendations from "../Components/generator-finder/Recommendations.vue";
import Resources from "../components/resources/Resources.vue";

const routes = [
    {
        path: "/seating-solution-finder/weight",
        alias: ['/seating-solution-finder', '/gb-ie/seating-solution-finder/weight', '/gb-ie/seating-solution-finder'],
        name: "Weight",
        component: ProductFinder,
        meta: { pageIndex: 1 }
    },
    {
        path: "/seating-solution-finder/transfer-method",
        alias: ['/gb-ie/seating-solution-finder/transfer-method'],
        name: "TransferMethod",
        component: ProductFinder,
        meta: { pageIndex: 2 }
    },
    {
        path: "/seating-solution-finder/fall-risk",
        alias: ['/gb-ie/seating-solution-finder/fall-risk'],
        name: "FallRisk",
        component: ProductFinder,
        meta: { pageIndex: 3 }
    },
    {
        path: "/seating-solution-finder/repositioning",
        alias: ['/gb-ie/seating-solution-finder/repositioning'],
        name: "Repositioning",
        component: ProductFinder,
        meta: { pageIndex: 4 }
    },
    {
        path: "/seating-solution-finder/stand",
        alias: ['/gb-ie/seating-solution-finder/stand'],
        name: "Stand",
        component: ProductFinder,
        meta: { pageIndex: 5 }
    },
    {
        path: "/seating-solution-finder/head-control",
        alias: ['/gb-ie/seating-solution-finder/head-control'],
        name: "HeadControl",
        component: ProductFinder,
        meta: { pageIndex: 6 }
    },
    {
        path: "/seating-solution-finder/recommendations",
        alias: ['/gb-ie/seating-solution-finder/recommendations'],
        name: "Recommendations",
        component: Recommendations,
        meta: { pageIndex: 7 }
    },
    {
        path: '/resources',
        alias: ['/gb-ie/resources'],
        name: 'resources',
        component: Resources
    },
    {
        path: '/resources/:resourceCategory',
        alias: ['/gb-ie/resources/:resourceCategory'],
        name: 'resourceCategory',
        component: Resources
    }
];
const router = new Router({
    mode: 'history',
    routes: routes,
    // scrollBehavior(to, from, savedPosition) {
    //     if (savedPosition) {
    //         return savedPosition;
    //     } else {
    //         return { x: 0, y: 0 };
    //     }
    // }
});

// Global navigation guard
router.beforeEach((to, from, next) => {
    if (from.name == null || from.path != to.path) {
        router.firstLoad = true;
    }
    next();
  });
  

export default router;